import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSentry } from '@/lib/sentry';
import './index.css';

// Initialize Sentry client error agent
initSentry();

// Suppress Recharts defaultProps warning in React 19.
// Recharts v2.15+ uses defaultProps internally; this filters out the
// React 19 deprecation warning without swallowing real errors.
const originalConsoleError = console.error;
console.error = (...args: unknown[]) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('defaultProps') &&
    args[0].includes('Warning:')
  ) {
    return;
  }
  originalConsoleError(...args);
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in document');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
